export default "__VITE_ASSET__BgmqKNy4__"